export interface Match {
  players: string[];
  score: [number, number];
  games: Game[];
  vod: string;
  finished: boolean;
  date: string;
  winner: string;
  map_bans?: string[];
  civ_bans?: string[];
  raw?: string;
}

export interface Game {
  map: string;
  played: boolean;
  teams: Team[];
}

export interface Team {
  name: string;
  players: string[];
  civs: TournamentCivAbrr | TournamentCivAbrr[];
  win: boolean;
}

export interface TournamentDraft {
  preset: string;
  host_name: string;
  guest_name: string;
  picks: string[];
  bans: string[];
}

export interface TournamentDataSection {
  body: string;
  drafts: Record<string, TournamentDraft>;
}

export interface TournamentData {
  liquipedia_updated_at: string;
  results: Record<string, Record<string, TournamentDataSection>>;
}

export interface Tournament {
  id: number;
  name: string;
  url: string;
  tier: string;
  kind: string;
  start_date: string;
  end_date: string;
  cancelled: boolean;
  data: TournamentMetadata;
  updated_at: string;
  image_url: string;
}

interface TournamentMetadata {
  mode: string;
  type: string;
  links: Links;
  prize: string;
  vanue?: any;
  format: string;
  series?: any;
  results: TournamentData;
  sponsor: string;
  location: string;
  organizer: string[] | string;
  winner_url?: any;
  winner_name?: any;
  players_count: number;
}

interface Links {
  home?: string;
  rules?: string;
  twitch?: string;
  discord?: string;
  twitter?: string;
  youtube?: string;
}

export const TOURNAMENT_CIV_ABBRS = ["abb", "ayy", "byz", "chi", "del", "eng", "fre", "hre", "hol", "jap", "jea", "knt", "mal", "mon", "ord", "ott", "rus", "zhu"] as const;
export const TOURNAMENT_DRAFT_CIVS = {
  "Abbasid": "abb",
  "Ayyubids": "ayy",
  "Byzantines": "byz",
  "Chinese": "chi",
  "Delhi": "del",
  "English": "eng",
  "French": "fre",
  "HRE": "hre",
  "Japanese": "jap",
  "Jeanne d'Arc": "jea",
  "Malians": "mal",
  "Mongols": "mon",
  "Order of the Dragon": "ord",
  "Ottomans": "ott",
  "Rus": "rus",
  "Zhu Xi's Legacy": "zhu",

  "aoe4.AbbasidDynasty": "abb",
  "aoe4.Ayyubids": "ayy",
  "aoe4.Byzantines": "byz",
  "aoe4.Chinese": "chi",
  "aoe4.DelhiSultanate": "del",
  "aoe4.English": "eng",
  "aoe4.French": "fre",
  "aoe4.HolyRomanEmpire": "hre",
  "aoe4.HouseOfLancaster": "hol",
  "aoe4.Japanese": "jap",
  "aoe4.JeanneDArc": "jea",
  "aoe4.KnightsTemplar": "knt",
  "aoe4.Malians": "mal",
  "aoe4.Mongols": "mon",
  "aoe4.OrderOfTheDragon": "ord",
  "aoe4.Ottomans": "ott",
  "aoe4.Rus": "rus",
  "aoe4.ZhuXiLegacy": "zhu",
} as const;
export type TournamentCivAbrr = "abb" | "ayy" | "byz" | "chi" | "del" | "eng" | "fre" | "hol" | "hre" | "jap" | "jea" | "knt" | "mal" | "mon" | "ord" | "ott" | "rus" | "zhu";

export const TOURNAMENT_CIV_ABBR_CORRECTIONS = {
  "aba": "abb",
  "jpn": "jap",
  "otm": "ott",
  "kni": "knt",
} as const;

export interface TournamentCivStats {
  civ: TournamentCivAbrr;
  wins: number;
  losses: number;
  played: number;
  mirrors: number;
  winrate: number;
  bans: number;
}

export interface TournamentPlayerStats {
  name: string;
  wins: 0;
  losses: 0;
  winrate: number;
  civs: Record<TournamentCivAbrr, { wins: number; losses: number; played: number }>;
}

export interface TournamentMapStats {
  map: string;
  played: number;
  bans: number;
  civs: Record<TournamentCivAbrr, { wins: number; losses: number; played: number }>;
}
